/* eslint-disable max-len */
import React, { useMemo } from 'react';
import styles from './index.module.scss';
export const ANIMATION_INTERVALS_COUNT = 50;
export const PROGRESS_BAR_MAX_WIDTH = 100;
const Lines = ({ itemsCount, prevIndex, currentElement, currentInterval }) => {
    const _getProgressBarOverlayWidth = useMemo(() => {
        return (PROGRESS_BAR_MAX_WIDTH
            - (PROGRESS_BAR_MAX_WIDTH / ANIMATION_INTERVALS_COUNT) * (ANIMATION_INTERVALS_COUNT - currentInterval));
    }, [currentInterval]);
    const _calcBarWidth = (key, prevElem) => {
        if (key === currentElement.index) {
            return _getProgressBarOverlayWidth;
        }
        if (prevElem) {
            return 300; // use more than 100 to get smooth transition (300)
        }
        return 0;
    };
    const _animationConfig = (key, prevElem) => {
        const elementWidth = _calcBarWidth(key, prevElem);
        return {
            width: `${elementWidth}%`,
            opacity: !elementWidth ? 0 : 1,
            left: prevElem ? `${500}%` : '0',
            transition: `left ${prevElem ? '1s' : '.3s'} linear .1s, width .1s linear, opacity .3s linear 0s`
        };
    };
    const renderLines = Array.from(Array(itemsCount).keys()).map((key) => {
        const isCurrentElem = key === currentElement.index;
        const isPrevElem = key - 1 === prevIndex && !isCurrentElem;
        return (React.createElement("div", { key: key, className: styles.barWrap },
            React.createElement("i", { className: styles.progressBar }),
            React.createElement("i", { className: styles.progressBarOverlay, style: _animationConfig(key, isPrevElem) })));
    });
    return React.createElement("div", { className: styles.progressBars }, renderLines);
};
export default Lines;
